import { Job, JobTag } from '@/_gql/graphql'

interface FilterParams {
  jobs: Job[]
  tag: string
  page: number
  limit: number
}
export function filterJobs({ jobs, tag, page, limit }: FilterParams): any {
  if (jobs) {
    const filteredJobs = jobs.filter((job: any) =>
      job.tags.some((t: any) => t.name.toLowerCase() === tag.toLowerCase())
    )

    // Step 2: Paginate the filtered jobs
    const startIndex = (page - 1) * limit
    const endIndex = startIndex + limit
    const paginatedJobs = filteredJobs.slice(startIndex, endIndex)

    const result = {
      data: paginatedJobs,
      totalData: filteredJobs.length,
    }
    return result
  }

  return []
}

interface MenuTab {
  key: string
  label: string
  colorLabel: string
  total: number
}

const getRandomColor = () => {
  const colorArray: string[] = [
    '#A7C3B0',
    '#FDC0AE',
    '#5AFEF4',
    '#FEA7D5',
    '#00A79D',
  ]

  return colorArray[Math.floor(Math.random() * colorArray.length)] ?? ''
}
export function getFilterTag(jobs: Job[], tag: JobTag[]) {
  if (!jobs) {
    return []
  }
  const MENUTAB: MenuTab[] = tag.map((t) => ({
    key: t.name,
    colorLabel: getRandomColor(),
    label: t.name,
    total: 0,
  }))

  MENUTAB.forEach((tag) => {
    const totalCount = jobs
      .filter((job) => job.tags && job.tags.some((t) => t.name === tag.key))
      .reduce((count) => count + 1, 0)
    tag.total = totalCount
  })

  return MENUTAB.filter((tag) => tag?.total > 0)
}
